//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { NsIcon } from "@nuskin/design-components";
import NsImage from "./NsImage.vue";
import NsProductDetailCarousel from "./NsProductDetailCarousel.vue";
import NsProductVariantSelector from "./NsProductVariantSelector.vue";
import NsMessageAction from "./NsMessageAction.vue";
import NsProductPrice from "./NsProductPrice.vue";
import NsProductSkuPoints from "./NsProductSkuPoints.vue";
import NsLoyaltyInformation from "./NsLoyaltyInformation.vue";
import NsProductQuantitySelector from "./NsProductQuantitySelector.vue";
import NsProductDetailInfo from "./NsProductDetailInfo.vue";
import NsPayPalPayLater from "./NsPayPalPayLater.vue";
import "@nuskin/ns-core-styles/src/dist/main.css";

/**
 * NsProductDetailBase
 *
 * How to use: You shouldn't use this component. Use NsProductDetail instead. It
 * includes the Product mixin. This component is simply all the html and styles.
 *
 * @event variant-select  When a variant selection occurs, this event emits a
 * function with params: (value, index)
 * @event quantity-select  When a quantity selection occurs, this event emits a
 * function with params: (value, index)
 * @event add-to-cart  When clicking on "Add to Cart", this event emits a
 * function with params: ()
 * @event add-to-adr  When clicking on "Add to Adr", this event emits a function
 * with params: ()
 * @event favorite-click  When clicking on "Favorites" icon, this event emits
 * a function with params: ()
 * @event image-select  When clicking on the image carousel, this event emits
 * a function with params: (index)
 */

export default {
  name: "NsProductDetailBase",
  components: {
    NsIcon,
    NsImage,
    NsProductDetailCarousel,
    NsProductVariantSelector,
    NsProductQuantitySelector,
    NsMessageAction,
    NsProductPrice,
    NsProductSkuPoints,
    NsLoyaltyInformation,
    NsProductDetailInfo,
    NsPayPalPayLater
  },
  props: {
    /**
     * ADR price value
     */
    adrPrice: {
      type: String,
      default: ""
    },
    adrPriceType: {
      type: String,
      default: ""
    },
    checkedQualifications: Boolean,
    /**
     * Product description
     */
    description: {
      type: String,
      default: ""
    },
    /**
     * Disables Add to ADR button
     */
    disableAddToAdr: Boolean,
    /**
     * Disables Add to Cart button
     */
    disableAddToCart: Boolean,
    /**
     * Disables the quantity selector
     */
    disableQuantitySelector: Boolean,
    /**
     * Enables the PayPal text, used to determine if we should show the Pay Later component
     */
    enablePayPalText: Boolean,
    /**
     * Message that will be shown on the exclusive offer ns-message-action component
     */
    exclusiveOfferMessage: {
      type: String,
      default: ""
    },
    forcesv: Boolean,
    featureFlags: {
      type: Object,
      default() {
        return {};
      }
    },
    /**
     * Override hiding all components associated with ADR
     */
    hideAdr: Boolean,
    hideExclusiveIcon: Boolean,
    hideExclusiveTextOnMobile: Boolean,
    hideFavorites: Boolean,
    hideInfo: Boolean,
    // TODO: class to prop
    hideSku: Boolean,
    imageFallbackSrc: {
      type: String,
      default: ""
    },
    image: {
      type: Object,
      default() {
        return {};
      }
    },
    /**
     * Array of all images for a product
     */
    imageSet: {
      type: Array,
      default() {
        return [];
      }
    },
    isBaseSku: Boolean,
    isDistributor: Boolean,
    isExclusive: Boolean,
    isFavorite: Boolean,
    isLoggedIn: Boolean,
    isLoyaltyEnabled: Boolean,
    isSale: Boolean,
    loyaltyStatusAndLinks: {
      type: Object,
      default() {
        return {};
      }
    },
    maxQuantity: {
      type: Number,
      default: null
    },
    marketAttributes: {
      type: Object,
      default() {
        return {};
      }
    },
    maxPrice: {
      type: String,
      default: ""
    },
    minPrice: {
      type: String,
      default: ""
    },
    /**
     * Product netto weight
     */
    nettoWeight: {
      type: String,
      default: ""
    },
    /**
     * This will force the ADR
     */
    originalPrice: {
      type: String,
      default: ""
    },
    originalPriceLabel: {
      type: String,
      default: ""
    },
    originalPriceType: {
      type: String,
      default: ""
    },
    points: {
      type: String,
      default: null
    },
    price: {
      type: Number,
      default: null
    },
    priceLabel: {
      type: String,
      default: ""
    },
    priceType: {
      type: String,
      default: ""
    },
    product: {
      type: Object,
      default() {
        return {};
      }
    },
    /**
     * Quantity of product available
     */
    quantity: {
      type: Number,
      default: null
    },
    /**
     * Product Sales Event Text
     */
    salesEventText: {
      type: String,
      default: ""
    },
    salesLabel: {
      type: String,
      default: ""
    },
    /**
     * Force showing the ADR price
     */
    showAdrPrice: Boolean,
    showAdrOnly: Boolean,
    showExclusiveOfferMessage: Boolean,
    showOriginalCrossedOut: Boolean,
    showPriceLabels: Boolean,
    showVariantSelector: Boolean,
    /**
     * Product size weight
     */
    sizeWeight: {
      type: String,
      default: ""
    },
    /**
     * Product sku
     */
    sku: {
      type: String,
      default: ""
    },
    /**
     * Warning message, if product is out of stock or whatever
     */
    statusMessage: {
      type: String,
      default: ""
    },
    /**
     * Warning message key, for qa testing automation
     */
    statusMessageKey: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    translations: {
      type: Object,
      default() {
        return {};
      }
    },
    userIsQualified: Boolean,
    userLoyalty: {
      type: Object,
      default() {
        return {};
      }
    },
    /**
     * Array of variant skus for the variant selector, if base sku
     */
    variantSkus: {
      type: Array,
      default() {
        return [];
      }
    },
    /**
     * Array of variant skus for the variant selector, if base sku
     */
    variants: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      columnOne: [],
      columnTwo: [],
      showFavoritesText: false,
      /**
       * Index of the currently selected slide from the image carousel
       */
      slideIndex: 0,
      /**
       * True during slide transitions
       */
      slideTransitioning: false,
      analyticsInterval: null
    };
  },
  computed: {
    desktopAndUp() {
      return ["desktop", "desktopHD"].includes(this.$mq);
    },
    phabletAndDown() {
      return ["mobile", "phablet"].includes(this.$mq);
    },
    showPrices() {
      return (
        (this.price && this.price !== "0") ||
        (this.minPrice && this.minPrice !== "0")
        // Note: We are showing the [retail] price even if the user isn't qualified to purchase
        // !(this.isExclusive && !this.userIsQualified)
      );
    },
    showSkuPoints() {
      return !this.isBaseSku && !(this.hideSku && !this.isDistributor);
    },
    showPayLater() {
      return !this.showAdrOnly && this.enablePayPalText;
    },
    payLaterAmount() {
      return this.price * this.quantity;
    }
  },
  watch: {
    product: {
      immediate: true,
      handler(newValue) {
        this.setDetailInfo(newValue);
      }
    }
  },
  mounted() {},
  destroyed() {
    if (this.analyticsInterval) {
      clearInterval(this.analyticsInterval);
    }
  },
  methods: {
    /**
     * Adds the product to cart
     */
    handleAddToCart() {
      /**
       * Fired when the add to cart button is clicked: function() => void
       *
       * @type {click}
       */
      this.$emit("add-to-cart");
    },
    /**
     * Adds the product to ADR
     */
    handleAddToAdr() {
      /**
       * Fired when the add to Adr button is clicked: function() => void
       *
       * @type {click}
       */
      this.$emit("add-to-adr");
    },
    /**
     * Adds the product to Favorites
     */
    handleFavoriteClick() {
      /**
       * Fired when the add to Favorite icon is clicked: function() => void
       *
       * @type {click}
       */
      this.$emit("favorite-click");
    },
    /**
     * Sets quantity
     */
    handleQuantitySelect(selected, index) {
      /**
       * Fired when a new quantity is selected: function(value: string|number, index: number) => void
       *
       * @type {select}
       * @property {(string|number)} value data-value attribute of the selected item, or index
       * @property {number} index index of the selected item
       */
      this.$emit("quantity-select", selected, index);
    },
    handleShowFavoritesText(shouldShow) {
      this.showFavoritesText = shouldShow;
    },
    /**
     * Sets product to new selection
     */
    handleSelectVariant(selected, index) {
      /**
       * Fired when a new variant is selected: function(value: string|number, index: number) => void
       *
       * @type {select}
       * @property {(string|number)} value data-value attribute of the selected item, or index
       * @property {number} index index of the selected item
       */
      this.$emit("variant-select", selected, index);
    },
    /**
     * Sets product image to new slide selection
     */
    handleSlideSelect(slideIndex) {
      if (slideIndex !== this.slideIndex) {
        this.slideTransitioning = true;

        setTimeout(() => {
          this.slideIndex = slideIndex;
          this.$emit("image-select", slideIndex);
          this.slideTransitioning = false;
        }, 200);
      }
    },
    /**
     * Set content for content blocks on bottom half of pdp
     * @param product
     */
    setDetailInfo(product) {
      if (!product) return;

      this.columnOne = [];
      this.columnTwo = [];

      const BLOCKS = [
        "videos",
        "benefits",
        "usage",
        "ingredients",
        "resources",
        "movie"
      ];
      const detailInfoData = [];

      BLOCKS.forEach(block => {
        if (
          product[block] &&
          (product[block][block + "Text"] ||
            product[block][block + "HTML"] ||
            product[block][block + "Items"])
        ) {
          detailInfoData.push({
            id: block,
            title:
              product[block][block + "Text"] ||
              product[block]["tdc_videosText"] ||
              "",
            content: product[block][block + "HTML"] || "",
            items: product[block][block + "Items"] || [],
            type: block !== "movie" ? block : "videos"
          });
        }
      });

      if (product.youtube && product.youtube.videoID) {
        detailInfoData.push({
          id: "youtube",
          title: product.youtube.tdc_youtubeText || "",
          content:
            "<iframe frameborder='0' scrolling='no' allowfullscreen='allowfullscreen' marginheight='0' marginwidth='0' type='text/html' " +
              "src='https://www.youtube.com/embed/" +
              product.youtube.videoID +
              "?origin=https://nuskin.com' " +
              "height='" +
              product.youtube.height +
              "' width='" +
              product.youtube.width +
              "'></iframe>" || "",
          items: [],
          type: "videos"
        });
      }

      this.setDetailInfoColumns(detailInfoData);

      //If content was not entered in specific drawers check legacy drawers
      if (this.columnOne.length === 0 && this.columnTwo.length === 0) {
        if (
          Array.isArray(product.contentSection) &&
          product.contentSection.length > 0
        ) {
          const legacyDrawerContent = product.contentSection[0];
          if (legacyDrawerContent.sectionContent) {
            this.setDetailInfoColumns(
              this.createLegacyContentDrawerData(
                legacyDrawerContent.sectionContent
              )
            );
          }
        }
      }
    },

    /**
     * Adds content in array to each column depending the size of the content
     */
    setDetailInfoColumns(contentArray) {
      if (Array.isArray(contentArray) && contentArray.length > 0) {
        this.columnOne = contentArray.filter((info, index) => index % 2 === 0);
        this.columnTwo = contentArray.filter((info, index) => index % 2 !== 0);
      }
    },

    /**
     * Programmatically create stacked content blocks
     * @param {string} contents
     */
    createLegacyContentDrawerData(contents) {
      let ele = document.createElement("column-content");
      ele.innerHTML = contents;
      let contentSections = ele.children;
      let data = [];
      if (contentSections && contentSections.length > 0) {
        for (let i = 0; i < contentSections[0].children.length; i++) {
          let el = contentSections[0].children[i];
          let h3 = el.getElementsByTagName("h3");
          let content = el.getElementsByClassName("sectionContent");
          if (h3.length > 0 && content.length > 0 && content[0].innerHTML) {
            data.push({
              id: `legacy-${i}`,
              title: h3[0].innerText,
              content: content[0].innerHTML,
              type: h3
            });
          }
        }
      }

      return data;
    }
  }
};
